import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import type { BlogSport } from 'constants/types';

import type { getPostCategory_Post } from './__generated__/postCategory.graphql';

type Post = getPostCategory_Post;

export const getPostCategory = (post: Post): BlogSport => {
  if (
    post.categories?.nodes.find(
      category => category.slug?.indexOf('football') !== -1
    )
  ) {
    return 'football';
  }
  if (
    post.categories?.nodes.find(
      category => category.slug?.indexOf('nba') !== -1
    )
  ) {
    return 'nba';
  }
  if (
    post.categories?.nodes.find(
      category => category.slug?.indexOf('mlb') !== -1
    )
  ) {
    return 'mlb';
  }
  return 'football';
};

getPostCategory.fragments = {
  post: gql`
    fragment getPostCategory_Post on Post {
      categories {
        nodes {
          name
          slug
        }
      }
    }
  ` as TypedDocumentNode<getPostCategory_Post>,
};
